import { Dropdown } from "semantic-ui-react";
import { APICall } from "../../../api_helper";
import { useMutationWrapper } from "../../../helper";

export const ApiCallCardDotMenuItemComponent = (props: {
  props: ApiCallCardDotMenuItemComponentProps;
  cardData: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  const [mutation] = useMutationWrapper(
    props.props.apiCall.documentNode,
    (data) => {
      props.props.callback(
        props.props.apiCallVariables(data),
        props.setReloadKey,
        props.pageData,
        props.setPageData,
      );
    },
  );

  return (
    <>
      {props.props.showMenuOption(props.cardData) && (
        <Dropdown.Item
          text={props.props.label}
          onClick={() => {
            mutation({
              variables: props.props.apiCallVariables(props.cardData),
            });
          }}
        ></Dropdown.Item>
      )}
    </>
  );
};

export type ApiCallCardDotMenuItemComponentProps = {
  type: "api_call";
  apiCallVariables: (data: any) => any;
  apiCall: APICall;
  showMenuOption: (data: any) => boolean;
  callback: (
    data: any,
    setReloadKey: any,
    pageData: any,
    setPageData: any,
  ) => void;
  label: string;
};
